import { axios } from '@/utils/request'

export default {
    createStudent(input){
        return axios.post('/api/services/app/Student/CreateStudent',input)
    },
    updateStudent(input){
        return axios.put('/api/services/app/Student/UpdateStudent',input)
    },
    getStudents(input){
        return axios.get('/api/services/app/Student/GetStudents',{params:input})
    },
    getBaseInfos(input){
        return axios.get('/api/services/app/Student/GetBaseInfos',{params:input})
    },
    getSchools(){
        return axios.get('/api/services/app/Student/GetSchools')
    },
    getEnrollClass(input){
        return axios.get('/api/services/app/Student/GetEnrollClass',{params:input})
    },
    getStudentClass(input){
        return axios.get('/api/services/app/Student/GetStudentClass',{params:input})
    }
}